import { ActionReducer } from '@ngrx/store';
import { AccountGroup } from '../model/account-group/account-group.model';
import { Product } from '../model/account-group/product.model';

export const toggleEnableProduct: ActionReducer<Product> = (state: Product, action: any) => {
    if (state.name === action.payload.product.name  &&  state.number === action.payload.product.number) {
        return {...state, enabled: !state.enabled};
    }

    return state;
};

export const toggleEnableProducts: ActionReducer<Product[]> = (state: Product[], action: any) => {
    return state.map(g => toggleEnableProduct(g, action));
};


export const toggleEnableProductAccountGroup: ActionReducer<AccountGroup> = (state: AccountGroup, action: any) => {
    if (state.name !== action.payload.accountGroup.name) {
        return state;
    }

    return {...state, products: toggleEnableProducts(state.products, action)};
};

export const toggleEnableProductAccountGroups: ActionReducer<AccountGroup[]> = (state: AccountGroup[], action: any) => {
    return state.map(g => toggleEnableProductAccountGroup(g, action));
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/reducers/toggle-enable-product-account-groups.reducer.ts